function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916663 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1072",
    transform: "matrix(1.1802925,0,0,1.1936159,-114.20129,-106.3882)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.25,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect1096",
    width: 4.2333331,
    height: 5.2916665,
    x: 96.883331,
    y: 89.254562
  }), /*#__PURE__*/React.createElement("g", {
    id: "g81659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1200",
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: 0.25,
      strokeLinecap: "square",
      strokeOpacity: 1
    },
    d: "m 97.870186,92.179352 h 0.547781 v 0.821671 h -0.547781 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1202",
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: 0.25,
      strokeLinecap: "square",
      strokeOpacity: 1
    },
    d: "m 98.763298,92.179352 0.855815,-0.529167 v 1.880008 l -0.855815,-0.529167 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOff);
export default __webpack_public_path__ + "static/media/audio_off.0cd6bd397986807a7853343466dd9f67.svg";
export { ForwardRef as ReactComponent };